import { GetEvent } from "@ticketingplatform/api/dist/event/__generated__/GetEvent";
import pick from "lodash/fp/pick";
import { pickTicketPoolFormFields } from "views/TicketTemplates/TicketTemplateCreate/utils";

import { EventFormProps } from "../EventForm/types";

const pickPresalePasswordsFormFields = pick(["name", "password", "expireAt"]);

export const parseEventDataToFormValues = (
  data: GetEvent | null | undefined
): EventFormProps["initialValues"] => {
  if (!data?.event) {
    return undefined;
  }

  const {
    ticketPools,
    presalePasswords,
    discountCodes,
    image,
    __typename: _,
    seatMap,
    ...event
  } = data.event;

  return {
    input: {
      ...event,
      seatMap: seatMap || undefined,
      image: image || undefined,
      discountCodes: discountCodes?.nodes,
      ticketPools: ticketPools?.nodes.map((ticketPool) => ({
        ...pickTicketPoolFormFields(ticketPool),
        hasAnyTicketSold: ticketPool.hasAnyTicketSold || false,
        id: ticketPool.id.toString(),
      })),
      presalePasswords: presalePasswords?.nodes.map((presalePassword) => ({
        ...pickPresalePasswordsFormFields(presalePassword),
        id: presalePassword.id.toString(),
      })),
    },
  };
};
